import React from "react";
import { CapOneDisclaimers } from "./CapOneDisclaimers/CapOneDisclaimers";
const ImportantInformation = (_props) => {
    return (<div className="vr vr_x5">
			<div className="text">
				
				<CapOneDisclaimers />
			</div>
		</div>);
};
export default ImportantInformation;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/ImportantInformation/Disclaimers/Disclaimers-CapOne.tsx